/**
 * Generated by orval
 * Do not edit manually.
 * IP Fabric API
 * IP Fabric API documentation. For details see [IP Fabric API documentation](https://docs.ipfabric.io/main/IP_Fabric_API/)
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  PostTablesInventoryInterfaces200,
  PostTablesInventoryInterfacesBody,
} from '../../schemas';

import { apiClient } from '../../../apiClient';

/**
 * Interface Inventory table represents information about every discovered interface in the network, including the state information as observed during the last analysis.
 * @summary Interface Inventory
 */
export const postTablesInventoryInterfaces = (
  postTablesInventoryInterfacesBody: PostTablesInventoryInterfacesBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesInventoryInterfaces200>({
    url: `/tables/inventory/interfaces`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesInventoryInterfacesBody,
    signal,
  });
};

export const getPostTablesInventoryInterfacesQueryKey = (
  postTablesInventoryInterfacesBody: PostTablesInventoryInterfacesBody,
) => {
  return [
    `/tables/inventory/interfaces`,
    postTablesInventoryInterfacesBody,
  ] as const;
};

export const getPostTablesInventoryInterfacesQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesInventoryInterfaces>>,
  TError = unknown,
>(
  postTablesInventoryInterfacesBody: PostTablesInventoryInterfacesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesInventoryInterfaces>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesInventoryInterfacesQueryKey(postTablesInventoryInterfacesBody);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesInventoryInterfaces>>
  > = ({ signal }) =>
    postTablesInventoryInterfaces(postTablesInventoryInterfacesBody, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesInventoryInterfaces>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesInventoryInterfacesQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesInventoryInterfaces>>
>;
export type PostTablesInventoryInterfacesQueryError = unknown;

export function usePostTablesInventoryInterfaces<
  TData = Awaited<ReturnType<typeof postTablesInventoryInterfaces>>,
  TError = unknown,
>(
  postTablesInventoryInterfacesBody: PostTablesInventoryInterfacesBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesInventoryInterfaces>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesInventoryInterfaces>>,
          TError,
          Awaited<ReturnType<typeof postTablesInventoryInterfaces>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesInventoryInterfaces<
  TData = Awaited<ReturnType<typeof postTablesInventoryInterfaces>>,
  TError = unknown,
>(
  postTablesInventoryInterfacesBody: PostTablesInventoryInterfacesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesInventoryInterfaces>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesInventoryInterfaces>>,
          TError,
          Awaited<ReturnType<typeof postTablesInventoryInterfaces>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesInventoryInterfaces<
  TData = Awaited<ReturnType<typeof postTablesInventoryInterfaces>>,
  TError = unknown,
>(
  postTablesInventoryInterfacesBody: PostTablesInventoryInterfacesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesInventoryInterfaces>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Interface Inventory
 */

export function usePostTablesInventoryInterfaces<
  TData = Awaited<ReturnType<typeof postTablesInventoryInterfaces>>,
  TError = unknown,
>(
  postTablesInventoryInterfacesBody: PostTablesInventoryInterfacesBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesInventoryInterfaces>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesInventoryInterfacesQueryOptions(
    postTablesInventoryInterfacesBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
